import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-sale-payment-success',
  templateUrl: './custom-sale-payment-success.component.html',
  styleUrls: ['./custom-sale-payment-success.component.scss']
})
export class CustomSalePaymentSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
